import { addDays, format, setHours, setMinutes, setSeconds, startOfWeek } from "date-fns";

export interface ProposedPollDate {
  proposed_date: string;
  label: string;
}

function parseDefaultTime(time: string): [number, number] {
  const [h, m] = time.split(":");
  return [parseInt(h, 10) || 20, parseInt(m, 10) || 0];
}

/** Build poll option candidates from group_settings candidate_days (0=Sun) and default_time. */
export function buildProposedDatesFromSettings(
  candidateDays: number[],
  defaultTime: string | null
): ProposedPollDate[] {
  if (candidateDays.length === 0) return [];

  const now = new Date();
  const weekStart = startOfWeek(now, { weekStartsOn: 0 });
  const [hours, minutes] = parseDefaultTime(defaultTime ?? "20:00");

  return [...candidateDays]
    .sort((a, b) => a - b)
    .map((dayOfWeek) => {
      let date = addDays(weekStart, dayOfWeek);
      date = setSeconds(setMinutes(setHours(date, hours), minutes), 0);

      if (date < now) {
        date = addDays(date, 7);
      }

      return {
        proposed_date: date.toISOString(),
        label: format(date, "EEEE d MMM, HH:mm"),
      };
    });
}

/** Option id the given user voted for on an open poll, if any. */
export function getUserPollVoteOptionId(
  options: { id: string; votes?: { user_id: string | null; poll_option_id?: string }[] }[] | undefined,
  userId: string | null
): string | null {
  if (!options || !userId) return null;

  for (const opt of options) {
    if (opt.votes?.some((v) => v.user_id === userId)) {
      return opt.id;
    }
  }
  return null;
}
